<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
      
      </v-col>

      <v-col class="mb-4">
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { decodeUser } from '@/libs';
const Cookies = require('js-cookie');

export default {
    mounted() {
        if (window.location.hash) { // Get cookie hashes from url and set them.
            // Remove first character '#' then split by '&'
            let hashes = window.location.hash.substr(1).split('&');
            hashes = hashes.reduce((accum, curr) => {
                const [key, value] = curr.split('=');
                accum[key] = value;
                return accum;
            }, {});
            const keys = ['access_token', 'id_token'];
            keys.forEach((k) => {
                if (Object.prototype.hasOwnProperty.call(hashes, k)) {
                    Cookies.set(k, hashes[k], {
                        // Set cookie expiration to match cognito's (from hashes). Convert to ms.
                        expires: new Date(new Date().getTime() + hashes.expires_in * 1000),
                    });
                }
            });
            if (hashes.id_token) {
                let user = decodeUser(hashes.id_token);
                this.setUser({
                    name: user.name_ccid,
                    ccid: user.ccid,
                    expires: new Date(new Date().getTime() + hashes.expires_in * 1000),
                    loggedIn: true
                });
                this.$router.push({path: '/'});
            } else {
                // Auth Failed.
            }
        }
        
    },
    methods: {
        ...mapActions(['setUser']),
    },
}

</script>